import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import LineChartDuo from './LineChartDuo';


const useStyles = makeStyles((theme) => ({
    rechartBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    title: {
        color: "#4D5766",
        wordSpacing: 2,
        fontSize: 18,
        marginBottom: 8,
        [theme.breakpoints.down('xs')]: {
            fontSize: 16,
        },
    },
    description: {
        fontSize: 14,
        lineHeight: 1.6,
        marginBottom: 16,
        [theme.breakpoints.down('xs')]: {
            fontSize: 13,
            marginBottom: 12,
        },
    },
    chartWrapper: {
        width: '100%',
        overflowX: 'visible',
        marginTop: 8,
        [theme.breakpoints.up('sm')]: {
            overflowX: 'auto',
        },
    },
}));

const ClosingTheGapAssessment = ({ title, description, data }) => {
    const classes = useStyles();

    return (
        <Grid container>
            <Grid item xs={12}>
                <h4 className={classes.title}>{title}</h4>
                <Grid container>
                    <Grid item xs={12}>
                        <p className={classes.description}>{description}</p>
                    </Grid>
                    <Grid item xs={12} className={classes.chartWrapper}>
                        <LineChartDuo
                            data={data}
                            firstKey='current'
                            secondKey='future'
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ClosingTheGapAssessment;